import React from "react";
import { FormattedMessage } from "react-intl";
import Modal from "theme/components/organisms/Modal";
import Button from "theme/components/atoms/Button";
import ModalContent from "./ModalContent";
import { withState } from "recompose";

const SizeGuide = (props) => {
  const { sizeGuide, attributeSetLabel, isOpen, setIsOpen } = props;

  if (!sizeGuide || !sizeGuide.sizes) {
    return null;
  }

  const handleButtonClick = () => setIsOpen(true);

  const renderContent = () => {
    if (attributeSetLabel === "Chaussons") {
      return (
        <div className="wrapper-sizeguide">
          <div>
            <img
              className="logo-sizeguide"
              src="./images/sizeguide-icon.png"
              alt="Size guide logo"
            />
          </div>
          <div className="size-message">
            <FormattedMessage
              id="components.organism.SizeGuide.title"
              defaultMessage="This model runs small."
            />
            <br />
            <FormattedMessage
              id="components.organism.SizeGuide.title2"
              defaultMessage="Take one size larger than your usual size."
            />
            <br />
            <span>
              <FormattedMessage
                id="components.organism.SizeGuide.linkLabel"
                defaultMessage="Sizes guide"
              />
            </span>
          </div>
        </div>
      );
    }

    return (
      <>
        <FormattedMessage
          id="components.organism.SizeGuide.title-default"
          defaultMessage="How to choose your size?"
        />
        <span className="default">
          <FormattedMessage
            id="components.organism.SizeGuide.linkLabel"
            defaultMessage="Sizes guide"
          />
        </span>
      </>
    );
  };

  return (
    <div className="size-guide">
      <Button onClick={handleButtonClick}>{renderContent()}</Button>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(!isOpen)}
        extraClass="size-guide__modal"
      >
        {isOpen && <ModalContent {...props} />}
      </Modal>
    </div>
  );
};

export default withState("isOpen", "setIsOpen", false)(SizeGuide);
